// Copyright (c) 2020 WiseTime. All rights reserved.

import { createAction } from "@reduxjs/toolkit"
import { CreateTimelineMarkerRequest } from "../../../generated/wisetime/user/timeline/v4/timeline_pb"

export const toolbarFiltersPersisted = createAction("toolbar/toolbar-filters-persisted")
export const toolbarFiltersPersistFailed = createAction("toolbar/toolbar-filters-persist-failed")

export const loadToolbarFiltersFromStorage = createAction("toolbar/load-toolbar-filters-from-storage")
export const toolbarFiltersLoadFailed = createAction("toolbar/toolbar-filters-load-failed")

export const countFilteredTimeRowsByDay = createAction("toolbar/count-filtered-time-rows-by-day")
export const createTimelineMarker = createAction<CreateTimelineMarkerRequest>("toolbar/create-timeline-marker")
